<template>
  <div class="collapsable" style="display: flex">
    <div style="flex: 5">
      <slot />
    </div>
    <div class="collapsable-btn" v-bind="$attrs">
      <VButton
        :id="id"
        :aria-expanded="String(!collapsed)"
        class="btn-white btn-icon"
        :title="collapsed ? $t('common.expand') : $t('common.collapse')"
        @click.stop="$emit('update:collapsed', collapsed)"
      >
        <VSvgIcon :name="collapsed ? 'navigation-down' : 'navigation-up'" variant="outlined" size="middle" />
        <label :for="id" class="sr-only">
          {{ collapsed ? $t('common.expand') : $t('common.collapse') }}
        </label>
      </VButton>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/Button';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'CollapsableHelper',

  components: {
    VButton,
    VSvgIcon,
  },

  inheritAttrs: false,

  props: {
    id: {
      type: String,
      required: false,
      default: () => Math.random().toString(36).substring(2),
    },

    collapsed: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
